export const DEFAULT_VI_AGENCY_DASHBOARD_URL =
  "https://agency.familyvitalinsights.com";

const BLOCKED_VI_DASHBOARD_HOSTS = new Set([
  "app.familyvitalinsights.com",
  "www.familyvitalinsights.com",
  "familyvitalinsights.com",
]);

/** Agency dashboard only — not the family app at app.familyvitalinsights.com */
export function normalizeViAgencyDashboardUrl(url) {
  const fallback = DEFAULT_VI_AGENCY_DASHBOARD_URL;
  const raw = String(url || fallback).trim();
  if (!raw) return fallback;

  try {
    const parsed = new URL(raw.startsWith("http") ? raw : `https://${raw}`);
    if (BLOCKED_VI_DASHBOARD_HOSTS.has(parsed.hostname.toLowerCase())) {
      return fallback;
    }
    return parsed.origin.replace(/\/$/, "");
  } catch (_err) {
    return fallback;
  }
}
